// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".k-field-rating__error[data-v-cadd8e82]{font-size:13px}.k-field-rating .k-card[data-v-cadd8e82]{box-shadow:none!important}.k-field-rating__star[data-v-cadd8e82]{margin-right:27px}@media screen and (max-width:599px){.k-field-rating__star[data-v-cadd8e82]{margin-right:9px}.k-field-rating__star .k-icon[data-v-cadd8e82]{height:30px!important}}.k-field-rating__star[data-v-cadd8e82]:last-child{margin-right:0}", ""]);
// Exports
module.exports = exports;
